import React from 'react'
import SignUpDetailsMainContent from './SignUpDetailsMainContent'

const SignUpDetailsBody = () => {
  return (
    <div className="view-qualities folded router-view-container">
      <SignUpDetailsMainContent />
    </div>  
  )
}

export default SignUpDetailsBody